/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
export { BinarizeFormBase as BinarizeForm } from './BinarizeForm.base.js'
